import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes";
import "./App.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";

ReactDOM.render(<Routes />, document.getElementById("root"));
